export { render } from "./_default/client";
export const clientRouting = true;
export const hydrationCanBeAborted = true;
